import { computed, getCurrentInstance } from 'vue';
import store from '@/store';
import { t } from '@/utils/i18n-helper'

export function usePresaleButtons(event) {
    const user = computed(() => store.getters.getUser);

    const ruta = computed(() => {
        return event.value.varias_sesiones
            ? 'front.eventos.sesiones'
            : 'front.eventos.show';
    });

    const registradoEnPreventa = computed(() => {
        return Boolean(
            user.value &&
            event.value.preventa?.registrado_en_preventa
        );
    });

    const mostrarVenta = computed(() => {
        return Boolean(
            user.value &&
            event.value.preventa?.venta_preventa_activa &&
            event.value.preventa?.registrado_en_preventa
        );
    });

    const desactivarVenta = computed(() => {
        return Boolean(
            user.value &&
            (
                !event.value.preventa?.puede_comprar_en_preventa ||
                event.value.preventa?.comprado_en_preventa
            )
        );
    });

    const desactivarPreventa = computed(() => {
        return Boolean(
            user.value &&
            (
                !event.value.preventa?.registro_preventa_activo ||
                event.value.preventa?.registrado_en_preventa
            )
        );
    });

    const mensaje = computed(() => {
        const preventa = event.value.preventa;

        if (!preventa) return null;

        if (preventa.comprado_en_preventa) {
            return t('preventa.ha_comprado_preventa');
        }

        if (preventa.solicitud_denegada) {
            return null;
        }

        if (
            preventa.venta_preventa_activa &&
            !preventa.puede_comprar_en_preventa
        ) {
            return t('preventa.solicitud_en_revision');
        }

        return null;
    });

    return {
        ruta,
        registradoEnPreventa,
        mostrarVenta,
        desactivarVenta,
        desactivarPreventa,
        mensaje,
        user
    };
}
